import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { LockCardStackRoutes, LockCardStackScreenProps } from './type';
import { LockCardWebZeroScreen } from './LockCardWebZero.screen';
import { LockCardNativeZeroScreen } from './LockCardNativeZero.screen';
import { UnlockCardWebZeroScreen } from './UnlockCardWebZero.screen';
import { UnlockCardNativeZeroScreen } from './UnlockCardNativeZero.screen';
import { CardStatus } from '../../enum';

export interface LockCardProps {}
export const LockCardConfirm: React.FC<LockCardStackScreenProps<LockCardStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, account, tab, onType, record, func, actionResponse, actionError, onData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  let type = record?.status == CardStatus.ACTIVE ? 'lock' : 'unlock';

  if (layout.isMobile) {
    return type == 'lock' ? (
      <LockCardNativeZeroScreen
        onClose={onGoBack}
        account={account}
        tab={tab}
        onType={onType}
        type={type}
        record={record}
        func={func}
        actionResponse={actionResponse}
        actionError={actionError}
        onData={onData}
        refresh={refresh}
      />
    ) : (
      <UnlockCardNativeZeroScreen
        onClose={onGoBack}
        account={account}
        tab={tab}
        onType={onType}
        type={type}
        record={record}
        func={func}
        actionResponse={actionResponse}
        actionError={actionError}
        onData={onData}
        refresh={refresh}
      />
    );
  }

  return type == 'lock' ? (
    <LockCardWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      onType={onType}
      type={type}
      record={record}
      func={func}
      actionResponse={actionResponse}
      actionError={actionError}
      onData={onData}
      refresh={refresh}
    />
  ) : (
    <UnlockCardWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      onType={onType}
      type={type}
      record={record}
      func={func}
      actionResponse={actionResponse}
      actionError={actionError}
      onData={onData}
      refresh={refresh}
    />
  );
};
